import axios from "axios";

// const base_url = "http://localhost:30007/api";
const base_url = "https://dsampapi.dealdrivetechnology.com/api";

export const apiClient = axios.create({
  baseURL: base_url,
  headers: {
    "Content-Type": "application/json",
  },
});

// Attach token to every request if available
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("admin_token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// 🔹 Register Admin
export const loginAdmin = async (email, password) => {
  try {
    const payload = { email, password };
    const response = await apiClient.post("/okoli/auth/login", payload);
    return response.data;
  } catch (error) {
    console.log("Response data:", error);
    throw error;
  }
};

export const getUserCount = async () => {
  const res = await apiClient.get("/okoli/users");
  return res.data; // { count: 0 }
};

// Get total users
export const getAllUsers = async ({page = 1, limit = 20, role}) => {
  try {
     const res = await apiClient.get("/okoli/users", {params: {page, limit, role}});
  return res.data;
  } catch (error) {
    console.log("Failed to fetch orders:", error.response?.data || error.message);
    throw error;
  }
};


export const createFaq = (data) => {
  try {
  const res = apiClient.post("/okoli/faqs", data);
  return res.data;
  } catch (error) {
    console.log(
      "Failed to create faqs:",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const getFaqs = async () => {
  try {
  const res = await apiClient.get("/okoli/faqs");
  return res.data;
  } catch (error) {
    console.log(
      "Failed to fetch faqs:",
      error.response?.data || error.message
    );
    throw error;
  }
};
export const updateFaq = (id, data) => {
  try {
  const res = apiClient.put(`/okoli/faqs/${id}`, data);
  return res.data;
  } catch (error) {
    console.log(
      "Failed to update faq:",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const deleteFaq = async (id) => {
  try {
    const res = await apiClient.delete(`/okoli/faqs/${id}`);
    return res.data;
  } catch (error) {
    console.error(
      "Failed to delete FAQ:",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const createHero = async (data) => {
  try {
  const res = await apiClient.post("/okoli/home/hero", data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
} catch (error) {
    console.log(
      "Failed to create:",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const getHero = async () => {
  try {
  const res = await apiClient.get("/okoli/home/hero");
  return res.data;
} catch (error) {
    console.log(
      "Failed to fetch hero section:",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const updateHero = async (data) => {
  try {
  const res = await apiClient.put(`/okoli/home/hero`, data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
} catch (error) {
    console.log(
      "Failed to update hero:",
      error.response?.data || error.message
    );
    throw error;
  }
};


export const createContactInfo = (data) => {
  try {
  const res = apiClient.post("/okoli/contact", data);
  return res.data;
  } catch (error) {
    console.log(
      "Failed to create contact info:",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const getContactInfo = async () => {
  try {
  const res = await apiClient.get("/okoli/contact");
  return res.data;
  } catch (error) {
    console.log(
      "Failed to fetch contact info:",
      error.response?.data || error.message
    );
    throw error;
  }
};
export const updateContactInfo = (id, data) => {
  try {
  const res = apiClient.put(`/okoli/contact/${id}`, data);
  return res.data;
  } catch (error) {
    console.log(
      "Failed to update contact info:",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const getContactInquiry = async () => {
  try {
  const res = await apiClient.get("/okoli/consultation");
  return res.data;
  } catch (error) {
    console.log(
      "Failed to fetch contact inquiry:",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const createSiteSettings = async (data) => {
  try {
  const res = await apiClient.post("/okoli/settings", data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
} catch (error) {
    console.log(
      "Failed to create:",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const getSiteSettings = async () => {
  try {
  const res = await apiClient.get("/okoli/settings");
  return res.data;
} catch (error) {
    console.log(
      "Failed to fetch:",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const updateSiteSettings  = async (data) => {
  try {
  const res = await apiClient.put(`/okoli/settings`, data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
} catch (error) {
    console.log(
      "Failed to update:",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const createImpactStory = async (data) => {
  try {
  const res = await apiClient.post("/okoli/stories", data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
} catch (error) {
    console.log(
      "Failed to create:",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const getImpactStories = async () => {
  try {
  const res = await apiClient.get("/okoli/stories");
  return res.data;
} catch (error) {
    console.log(
      "Failed to fetch hero section:",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const updateImpactStory = async (id, data) => {
  try {
  const res = await apiClient.put(`/okoli/stories/${id}`, data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
} catch (error) {
    console.log(
      "Failed to update hero:",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const deleteImpactStory = async (id, data) => {
  try {
  const res = await apiClient.delete(`/okoli/stories/${id}`, data);
  return res.data;
} catch (error) {
    console.log(
      "Failed to update hero:",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const createTestimonial = (data) => {
  try {
  const res = apiClient.post("/okoli/home/testimonials", data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
  } catch (error) {
    console.log(
      "Failed to create:",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const getTestimonials = async () => {
  try {
  const res = await apiClient.get("/okoli/home/testimonials");
  return res.data;
  } catch (error) {
    console.log(
      "Failed to fetch:",
      error.response?.data || error.message
    );
    throw error;
  }
};
export const updateTestimonial = (id, data) => {
  try {
  const res = apiClient.put(`/okoli/home/testimonials/${id}`, data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
  } catch (error) {
    console.log(
      "Failed to update:",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const deleteTestimonial = async (id, data) => {
  try {
  const res = await apiClient.delete(`/okoli/home/testimonials/${id}`, data);
  return res.data;
} catch (error) {
    console.log(
      "Failed to update:",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const createTeam = (data) => {
  try {
  const res = apiClient.post("/okoli/team", data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
  } catch (error) {
    console.log(
      "Failed to create:",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const getTeams = async () => {
  try {
  const res = await apiClient.get("/okoli/team");
  return res.data;
  } catch (error) {
    console.log(
      "Failed to fetch:",
      error.response?.data || error.message
    );
    throw error;
  }
};
export const updateTeam = (id, data) => {
  try {
  const res = apiClient.put(`/okoli/team/${id}`, data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
  } catch (error) {
    console.log(
      "Failed to update:",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const deleteTeam = async (id, data) => {
  try {
  const res = await apiClient.delete(`/okoli/team/${id}`, data);
  return res.data;
} catch (error) {
    console.log(
      "Failed to update:",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const createVolunteerOpportunity = (data) => {
  try {
  const res = apiClient.post("/okoli/volunteer-opportunities", data);
  return res.data;
  } catch (error) {
    console.log(
      "Failed to create:",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const getVolunteerOpportunities = async () => {
  try {
  const res = await apiClient.get("/okoli/volunteer-opportunities");
  return res.data;
  } catch (error) {
    console.log(
      "Failed to fetch:",
      error.response?.data || error.message
    );
    throw error;
  }
};
export const updateVolunteerOpportunity = (id, data) => {
  try {
  const res = apiClient.put(`/okoli/volunteer-opportunities/${id}`, data);
  return res.data;
  } catch (error) {
    console.log(
      "Failed to update:",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const deleteVolunteerOpportunity = async (id, data) => {
  try {
  const res = await apiClient.delete(`/okoli/volunteer-opportunities/${id}`, data);
  return res.data;
} catch (error) {
    console.log(
      "Failed to update:",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const createStatistic = (data) => {
  try {
  const res = apiClient.post("/okoli/statistics", data);
  return res.data;
  } catch (error) {
    console.log(
      "Failed to create:",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const getStatistics = async () => {
  try {
  const res = await apiClient.get("/okoli/statistics");
  return res.data;
  } catch (error) {
    console.log(
      "Failed to fetch:",
      error.response?.data || error.message
    );
    throw error;
  }
};
export const updateStatistic = (id, data) => {
  try {
  const res = apiClient.put(`/okoli/statistics/${id}`, data);
  return res.data;
  } catch (error) {
    console.log(
      "Failed to update:",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const deleteStatistic = async (id, data) => {
  try {
  const res = await apiClient.delete(`/okoli/statistics/${id}`, data);
  return res.data;
} catch (error) {
    console.log(
      "Failed to update:",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const createAboutUs = (data) => {
  try {
  const res = apiClient.post("/okoli/about", data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
  } catch (error) {
    console.log(
      "Failed to create about us:",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const getAboutUs = async () => {
  try {
  const res = await apiClient.get("/okoli/about");
  return res.data;
  } catch (error) {
    console.log(
      "Failed to fetch about us:",
      error.response?.data || error.message
    );
    throw error;
  }
};
export const updateAboutUs = (id, data) => {
  try {
  const res = apiClient.put(`/okoli/about/${id}`, data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
  } catch (error) {
    console.log(
      "Failed to update about us:",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const createDonation = async(data) => {
  try {
  const res = await apiClient.post("/okoli/donation", data);
  return res.data;
  } catch (error) {
    console.log(
      "Failed to create:",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const getDonations = async () => {
  try {
  const res = await apiClient.get("/okoli/donation");
  return res.data;
  } catch (error) {
    console.log(
      "Failed to fetch:",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const submitVolunteerApplication = (data) => {
  try {
  const res = apiClient.post("/okoli/volunteer-application", data);
  return res.data;
  } catch (error) {
    console.log(
      "Failed to create:",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const getVolunteers = async () => {
  try {
  const res = await apiClient.get("/okoli/volunteer-application");
  return res.data;
  } catch (error) {
    console.log(
      "Failed to fetch:",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const sendContactMessage = (data) => {
  try {
  const res = apiClient.post("/okoli/contact-message", data);
  return res.data;
  } catch (error) {
    console.log(
      "Failed to create:",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const getContacts = async () => {
  try {
  const res = await apiClient.get("/okoli/contact-message");
  return res.data;
  } catch (error) {
    console.log(
      "Failed to fetch:",
      error.response?.data || error.message
    );
    throw error;
  }
};

